import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PlycaDataService } from '../../services/plyca.service';
import { UIService } from '../ui.service';
import * as lodash from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { BaseWidget } from './baseWidget';

declare var jQuery: any;

@Component({
  selector: 'chart',
  templateUrl: 'chart.template.html',
})
export class chartComponent extends BaseWidget {
  @Input() title = 'Expedientes por tipo de procedimiento';
  @Input() chartType = 'doughnut';

  // //el componente puede recibir directamente los datos, o bien el identificador de un atributo para consultarlos
  // @Input() attributeId: string;
  // @Input() layoutClass: string;
  @Input() legend: string;

  @Input() chartData: any[] = [];
  @Input() chartLabels: Array<string> = [];
  // @Input() link: string;
  // @Input() linkParamName: string;
  // @Input() titleKey;
  // @Input() descriptionKey;
  @Input() labelColumnName: string;
  @Input() valuesColumnNames: string[];
  @Input() valuesType: string;
  @Input() seriesDescKeys: string[];
  @Input() chartOptions: any;
  // @Input() estilos: any;

  chartIds: Array<string> = [];

  dataSets: any[];

  colors: any;

  formatScaleOption: any;
  formatTooltipOption: any;

  loading = true;
  error = false;
  empty = false;
  expanded = false;

  // ngAfterContentInit(): void {
  // 	super.ngAfterContentInit();
  // 	this.reloadWidget('');
  // }
  _chartData: any;

  constructor(
    private router: Router,
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public translate: TranslateService
  ) {
    super();
    if (jQuery(document).width() < 769) {
      this.expanded = false;
    }
    const valuesType = this.valuesType;
  }

  reloadWidget(filters: string) {
    // OPCIONES GRAFICO
    const valuesType = this.valuesType;
    const translate = this.translate;
    this.formatScaleOption = {
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (value, index, values) {
                value = new Intl.NumberFormat(translate.currentLang, {
                  minimumFractionDigits: 2,
                }).format(Number(value));
                switch (valuesType) {
                  case 'CURRENCY':
                    return value.toLocaleString(translate.currentLang) + ' €';
                  default:
                    return value;
                }
              },
            },
          },
        ],
      },
    };
    this.formatTooltipOption = {
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            let label = data.datasets[tooltipItem.datasetIndex].label || '';

            if (label) {
              label += ': ';
            }
            if (tooltipItem.yLabel) {
              label += new Intl.NumberFormat(translate.currentLang, {
                minimumFractionDigits: 2,
              }).format(Number(tooltipItem.yLabel));
            } else {
              label += new Intl.NumberFormat(translate.currentLang, {
                minimumFractionDigits: 2,
              }).format(
                Number(
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ]
                )
              );
            }

            switch (valuesType) {
              case 'CURRENCY':
                return label + ' €';
              default:
                return label;
            }
          },
        },
      },
    };
    // CARGA DE DATOS UTILIZANDO ATRIBUTOS
    if (this.attributeId) {
      this._chartData=null;
      this.colors = {}; // this.uiService.getCHART_COLORS(this.chartType);
      this.subscribe(
        this.plycaService.getAttributeValue(this.attributeId, filters),
        (x: any) => {
          //limpiamos datos si los hubiera de una carga anterior
          if(this.chartData && this.chartData.length>0)
            this.chartData.splice(0, this.chartData.length);
          if(this.chartLabels && this.chartLabels.length>0)
            this.chartLabels.splice(0, this.chartLabels.length);
          if (x.values) {
            let datos: Array<any> = x.values;
            datos.forEach((col) => {
              // 							console.log ('dato: ' + col.DESCRIPTION + ":" + col.CUENTA);
              if (
                !this.valuesColumnNames ||
                this.valuesColumnNames.length === 0
              ) {
                let v: number = col.columns.CUENTA.value;
                this.chartData.push(v);
              } else {
                if (!this.dataSets) {
                  this.dataSets = [];
                  this.colors = [];
                  this.valuesColumnNames.forEach((valColumn, index) => {
                    let dataset = {};
                    if (
                      this.seriesDescKeys &&
                      this.seriesDescKeys.length > index
                    ) {
                      dataset['label'] = this.translate.instant(
                        this.seriesDescKeys[index]
                      );
                    } else {
                      dataset['label'] = valColumn;
                    }
                    let color = {};
                    // color["backgroundColor"] = this.uiService.chartColorsDef.hoverBackgroundColor[index];
                    // color["hoverBackgroundColor"] = this.uiService.chartColorsDef.hoverBackgroundColor[index];
                    // color["borderColor"] = this.uiService.chartColorsDef.borderColor[index];
                    this.colors.push(color);
                    dataset['data'] = [];
                    dataset['data'].push(col.columns[valColumn].value);
                    this.dataSets.push(dataset);
                  });
                } else {
                  this.valuesColumnNames.forEach((valColumn, index) => {
                    this.dataSets[index]['data'].push(
                      col.columns[valColumn].value
                    );

                    this.dataSets[index]['tension'] = 0.4;
                  });
                }
              }
              if (this.labelColumnName) {
                this.chartLabels.push(col.columns[this.labelColumnName].value);
              } else {
                this.chartLabels.push(col.columns.DESCRIPTION.value);
              }
              if (col.columns.ID) {
                this.chartIds.push(col.columns.ID.value);
              }
            });
            // se comprueba si el servicio ha devuelto datos
            this.empty = this.chartData.length === 0 && !this.dataSets;
          }
        },
        (err) => {
          this.error = true;
          this.loading = false;
        },
        () => {
          if (!this.dataSets) {
            this._chartData = {
              labels: this.chartLabels,
              datasets: [
                {
                  label: '',
                  data: this.chartData,
                  // El color de los puntos
                  borderColor: this.uiService.borderColor,
                  // El color de las lineas
                  backgroundColor: this.uiService.backgroundColor,
      
                  borderWith: 2,
                  options: this.uiService.barChartOptions,
                },
              ],
            };
            if (this.chartOptions && this.chartOptions.colors) {
              this._chartData.datasets.forEach((d,idx) => {
                if(this.chartOptions.colors[idx]){
                  d.backgroundColor = lodash.merge([], d.backgroundColor, this.chartOptions.colors[idx].backgroundColor);
                  d.borderColor = lodash.merge([], d.borderColor, this.chartOptions.colors[idx].borderColor);
                  d.hoverBackgroundColor = lodash.merge([], d.hoverBackgroundColor, this.chartOptions.colors[idx].hoverBackgroundColor);
                }
              })
            }
          }else{
            this._chartData = {
              labels: this.chartLabels,
              datasets: this.dataSets
            };
            if (this.chartOptions && this.chartOptions.colors) {
              this._chartData.datasets.forEach((d,idx) => {
                if(this.chartOptions.colors[idx]){
                  d.backgroundColor = this.chartOptions.colors[idx].backgroundColor;
                  d.borderColor = this.chartOptions.colors[idx].borderColor;
                  d.hoverBackgroundColor = this.chartOptions.colors[idx].hoverBackgroundColor;
                }
              })
            }
          }    
          this.loading = false;
        }
      );
    } else {
      this.empty = this.chartData.length === 0;
    }
    // Aplicando opciones del grafico
    if (!this.chartOptions) {
      this.chartOptions = this.uiService.barChartOptions;
    } else {
      this.chartOptions = lodash.merge(
        {},
        this.uiService.barChartOptions,
        this.chartOptions
      );
    }
    this.chartOptions = lodash.merge(
      {},
      this.chartOptions,
      this.formatTooltipOption
    );

    if (this.chartType !== 'pie' && this.chartType !== 'doughnut') {
      this.chartOptions = lodash.merge(
        {},
        this.chartOptions,
        this.formatScaleOption
      );
    }

    // if (this.chartOptions && this.chartOptions.colors) {
    // 	this.colors = lodash.merge([], this.colors, this.chartOptions.colors);
    // }
  }

  labelClicked(index: number): any {
    let val = this.chartIds[index];
    if (val) {
      this.navigate(val);
    }
  }
  chartClicked(e: any): any {
    let val = -1;
    if (e) {
      val = e.element.index;
    }

    this.labelClicked(val);
  }

  navigate(val: string) {
    console.log('navigate: ', this.link, val);
    if (this.link) {
      let params = {};
      if (this.linkParamName && val) {
        params[this.linkParamName] = val;
      }
      this.router.navigate([this.link], { queryParams: params });
    }
  }

  isLoading(): boolean {
    return this.loading;
  }

  chartHovered(): any {}

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error && !this.empty;
  }

  isEmpty(): boolean {
    return this.empty;
  }
}
